import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ClienteApiHttpService } from './cliente-api-http.service';
import { Router, UrlSerializer } from '@angular/router';
import { sp } from '@pnp/sp';
import pnp from '@pnp/pnpjs';
import { Deferred } from 'ts-deferred';
import { Constantes } from 'src/app/shared/utils/Constantes';

@Injectable({ providedIn: 'root' })
export class ComunicacionService {
  private uriNotificarExpedienteExterno: string = environment.apiUrlBackEnd + '/api/expediente/notificar-expediente-externo';
  private uriRegistrarComunicacion: string = environment.apiUrlBackEnd + '/api/mesapartes/registrar';
  private uriValidarExisteCarta: string = environment.apiUrlBackEnd + '/api/mesapartes/validar-existe-carta';
  private uriValidarExisteHRD: string = environment.apiUrlBackEnd + '/api/mesapartes/validar-existe-hrd';

  constructor(
    private clienteApiHtppService: ClienteApiHttpService,
    private router: Router,
    private serializer: UrlSerializer) {   
  }

  public registrarComunicacion(body: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.clienteApiHtppService.post(this.uriRegistrarComunicacion, body).subscribe(
        (res: any) => resolve(res),
        (error: any) => reject(error)
      );

    });
  }

  public notificarExpedienteExterno(body: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.clienteApiHtppService.post(this.uriNotificarExpedienteExterno, body).subscribe(
        (res: any) => resolve(res),
        (error: any) => reject(error)
      );

    });
  }

  public validarExisteCarta(numeroCarta : string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        this.clienteApiHtppService.get(this.uriValidarExisteCarta + "/" + numeroCarta).subscribe(
            (res: any) => resolve(res),
            (error: any) => reject(error)
        );
    });
  }

  public validarExisteHRD(numeroHRD : string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        this.clienteApiHtppService.get(this.uriValidarExisteHRD + "/" + numeroHRD).subscribe(
            (res: any) => resolve(res),
            (error: any) => reject(error)
        );
    });
  }

}
